import Type from '../type';

function getParser(format: any)
{
	switch (format)
	{
		case 'index':
			return (sourceKey: any, value: any, accumulator: any) => {
				const result = /\[(\w*)]$/.exec(sourceKey);
				const key = sourceKey.replace(/\[\w*]$/, '');

				if (Type.isNil(result))
				{
					accumulator[key] = value;

					return;
				}

				if (Type.isUndefined(accumulator[key]))
				{
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (sourceKey: any, value: any, accumulator: any) => {
				const result = /(\[])$/.exec(sourceKey);
				const key = sourceKey.replace(/\[]$/, '');

				if (Type.isNil(result))
				{
					accumulator[key] = value;

					return;
				}

				if (Type.isUndefined(accumulator[key]))
				{
					accumulator[key] = Type.isNil(value) ? [] : [value];

					return;
				}

				// eslint-disable-next-line unicorn/prefer-spread
				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return (sourceKey: any, value: any, accumulator: any) => {
				const key = sourceKey.replace(/\[]$/, '');
				accumulator[key] = value;
			};
	}
}

function getKeyFormat(key: any)
{
	if (/^\w+\[(\w+)]$/.test(key))
	{
		return 'index';
	}

	if (/^\w+\[]$/.test(key))
	{
		return 'bracket';
	}

	return 'default';
}

function isAllowedKey(key: string): boolean
{
	return !String(key).startsWith('__proto__');
}

function parseQuery(input: any)
{
	if (!Type.isString(input))
	{
		return {};
	}

	const url = input.trim().replace(/^[#&?]/, '');

	if (!url)
	{
		return {};
	}

	const params = url.split('&').reduce((acc, param) => {
		const [key, value] = param.replaceAll('+', ' ').split('=');
		if (isAllowedKey(key))
		{
			const keyFormat = getKeyFormat(key);
			const formatter = getParser(keyFormat);
			formatter(key, value, acc);
		}

		return acc;
	}, Object.create(null));

	return { ...params };
}

// eslint-disable-next-line unicorn/better-regex
const urlExp = /^((\w+):)?(\/\/((\w+)?(:(\w+))?@)?([^/:?]+)(:(\d+))?)?(\/?([^#/?][^#?]*)?)?(\?([^#]+))?(#((?:[\w-?/:@.~!$&'()*+,;=]|%\w{2})*))?/;

function prepareParams(params: { [key: string]: any }): { [key: string]: any }
{
	const paramsEntries: Array<[string, any]> = Object.entries(params);

	return paramsEntries.reduce((acc: { [key: string]: any }, [key, value]) => {
		if (Type.isNil(value))
		{
			acc[key] = '';
		}
		else if (Type.isPlainObject(value))
		{
			acc[key] = prepareParams(value);
		}
		else
		{
			acc[key] = value;
		}

		return acc;
	}, {});
}

export type ParsedUrl = {
	useShort: boolean,
	href: string,
	schema: string,
	host: string,
	port: string,
	path: string,
	query: string,
	sourceQueryParams: { [key: string]: string | null | undefined },
	queryParams: { [key: string]: string },
	hash: string,
	username: string,
	password: string,
	origin: string,
};

export default function parseUrl(url: any): ParsedUrl | Partial<Record<keyof ParsedUrl, undefined>>
{
	const result = url.match(urlExp);

	if (Type.isArray<string | undefined>(result))
	{
		const sourceParams: { [key: string]: string | null | undefined } = parseQuery(result[14]);
		const preparedParams: { [key: string]: string } = prepareParams(sourceParams);

		return {
			useShort: String(url).startsWith('//'),
			href: result[0] || '',
			schema: result[2] || '',
			host: result[8] || '',
			port: result[10] || '',
			path: result[11] || '',
			query: result[14] || '',
			sourceQueryParams: sourceParams,
			queryParams: preparedParams,
			hash: result[16] || '',
			username: result[5] || '',
			password: result[7] || '',
			origin: result[8] || '',
		};
	}

	return {};
}
